import classnames from 'classnames';
import { Wrapper } from './ScrollLineItem.style';

export type ScrollLineItemProps = {
  baseImageUrl: string;
  item: any;
  onClick: (item: any) => void;
  isSelected: boolean;
};

export function ScrollLineItem(props: ScrollLineItemProps) {
  const { item, isSelected } = props;

  const className = classnames('ScrollLineItem-wrapper', {
    selected: isSelected,
  });

  const style = {
    backgroundImage: `url(${item.thumbUrl})`,
  };

  return (
    <Wrapper
      style={style}
      className={className}
      data-testid='ScrollLineItem-wrapper'
      onClick={() => props.onClick(item)}
    ></Wrapper>
  );
}

export default ScrollLineItem;
